import React from "react";
import { v4 as uuidv4 } from "uuid";
import { PaziaChip } from "components/atoms";

export interface PaziaTableFilter {
  id: string;
  name: string;
}

interface PaziaTableFiltersProps {
  filters: PaziaTableFilter[];
  onFiltersChange?: (filters: PaziaTableFilter[]) => void;
  defaultFilters?: number[];
}

// TODO Name missleading?
export const PaziaTableFilters = ({ filters, onFiltersChange, defaultFilters }: PaziaTableFiltersProps) => {
  const [selectedFilters, setSelectedFilters] = React.useState<string[]>(
    (defaultFilters ?? []).map((x) => x.toString()),
  );

  const toggleFilter = (filter: PaziaTableFilter) => {
    const filtersToSet = selectedFilters.includes(filter.id)
      ? selectedFilters.filter((x) => x !== filter.id)
      : [...selectedFilters, filter.id];

    setSelectedFilters(filtersToSet);
    const selectedFiltersObjects = filters.filter((x) => filtersToSet.includes(x.id));
    if (onFiltersChange) onFiltersChange(selectedFiltersObjects);
  };

  const onAllClick = () => {
    setSelectedFilters([]);
    if (onFiltersChange) onFiltersChange([]);
  };

  return (
    <div className="mb-5">
      <ul className="-m-1 flex flex-wrap">
        <li className="m-1">
          <PaziaChip color={selectedFilters.length === 0 ? "primary" : "slate"} onClick={onAllClick}>
            Pokaż wszystkie
          </PaziaChip>
        </li>
        {filters.map((filtr) => (
          <li className="m-1" key={uuidv4()}>
            <PaziaChip
              color={selectedFilters.includes(filtr.id) ? "primary" : "slate"}
              onClick={() => toggleFilter(filtr)}
            >
              {filtr.name}
            </PaziaChip>
          </li>
        ))}
      </ul>
    </div>
  );
};
